module.exports = __webpack_public_path__ + "img/question.6d7b8bf5.svg";